import React from 'react';

interface DeltaChipProps {
  /** null = no value for the selected week (renders "no data"). */
  current: number | null;
  /** null = no earlier week with data to compare against. */
  previous: number | null;
  unit: 'pp' | 'volume';
  lowerIsBetter?: boolean;
}

function formatVolume(n: number): string {
  if (n >= 1000000) return `${(n / 1000000).toFixed(2)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toLocaleString();
}

const DeltaChip: React.FC<DeltaChipProps> = ({ current, previous, unit, lowerIsBetter }) => {
  if (current === null || previous === null) {
    return <span className="delta-chip delta-chip--neutral">— no data</span>;
  }
  const delta = current - previous;
  if (delta === 0) return <span className="delta-chip delta-chip--neutral">— no change</span>;
  const isGood = lowerIsBetter ? delta < 0 : delta > 0;
  const arrow = delta > 0 ? '▲' : '▼';
  const text = unit === 'pp'
    ? `${Math.abs(delta).toFixed(1)}% vs previous week`
    : `${formatVolume(Math.abs(delta))} vs previous week`;

  return (
    <span className={`delta-chip ${isGood ? 'delta-chip--good' : 'delta-chip--bad'}`}>
      {arrow} {text}
    </span>
  );
};

export default DeltaChip;
